var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('operational-area',{attrs:{"show":{
        operationalArea: !_vm.showScreen && _vm.show.menu,
        screen: !_vm.show.pause,
        iconClose: _vm.show.close || _vm.show.pause,
        closeButton: _vm.show.closeButton
    },"screen":{
        settings: {
            toggles: {
                request: _vm.toggleMessage,
                searchCall: _vm.searchingCall,
                callFound: _vm.requestFound,
                disabledButton: _vm.disableClose
            },
            loading: _vm.loading,
            showError: _vm.show.close
        }
    },"init":_vm.initMenu,"closeAction":_vm.closeMenu},scopedSlots:_vm._u([{key:"operational__screen__center",fn:function(){return [_c('div',{staticClass:"operate__standby"},[_c('pause',{attrs:{"actions":{
                    request: _vm.newRequest,
                    logout: _vm.closeMenu
                }},on:{"closeModal":function($event){_vm.show.closeModal = false}}})],1)]},proxy:true},{key:"operational__area",fn:function(){return [_c('call-area',{attrs:{"settings":Object.assign({}, {data: _vm.data,
                call: _vm.call},
                ( _vm.contact && _vm.contact.workflow && { workflow: _vm.contact.workflow } ),
                {showTimer: _vm.show.timer,
                timeBetweenCalls: _vm.timeBetweenCalls,
                blockTypification: _vm.block.typification})},on:{"new-request":_vm.newRequest,"show-pause":_vm.showPause,"close-menu":_vm.closeMenu,"stop-call":_vm.activateTimer}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }